export default "__VITE_PUBLIC_ASSET__df44a309__"